import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { Oval } from "react-loader-spinner"; // Import loader
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const BillsPage = () => {
  const [waterBill, setWaterBill] = useState(null);
  const [trashBill, setTrashBill] = useState(null);
  const [serviceBill, setServiceBill] = useState(null); // Add state for service bills
  const [token, setToken] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [rentalId, setRentalId] = useState("");
  const [isAddWaterBillModalOpen, setIsAddWaterBillModalOpen] = useState(false);
  const [previousUnits, setPreviousUnits] = useState("");
  const [currentUnits, setCurrentUnits] = useState("");
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedWaterBill, setSelectedWaterBill] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [trashAmount, setTrashAmount] = useState("");
  const [serviceAmount, setServiceAmount] = useState(""); // State for service bill amount
  const [isAddTrashBillModalOpen, setIsAddTrashBillModalOpen] = useState(false);
  const [isAddServiceBillModalOpen, setIsAddServiceBillModalOpen] = useState(false); // State for service bill modal
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const storedToken = localStorage.getItem("token");
      const storedPropertyId = localStorage.getItem("selectedPropertyId");
      const storedRentalId = localStorage.getItem("selectedRentalId");
      if (storedToken && storedPropertyId && storedRentalId) {
        setToken(storedToken);
        setPropertyId(storedPropertyId);
        setRentalId(storedRentalId);
        try {
          // Fetch Water Bill
          const waterBillResponse = await axios.get(
            `${StandardURL}/iNyumba/admin/waterbill/getspecificbyrental/${storedRentalId}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );
          setWaterBill(waterBillResponse.data.response);
          const newWaterBillId = waterBillResponse.data.response[0]?.waterbill_id;
          if (newWaterBillId) {
            localStorage.setItem("updatedWaterBillId", newWaterBillId);
          }
          // Fetch Trash Bill
          const trashBillResponse = await axios.get(
            `${StandardURL}/iNyumba/admin/trashbill/getspecificbyrental/${storedRentalId}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );
          setTrashBill(trashBillResponse.data.response);
          // Fetch Service Bill
          const serviceBillResponse = await axios.get(
            `${StandardURL}/iNyumba/admin/servicepropertybill/getspecificbyrental/${storedRentalId}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );
          setServiceBill(serviceBillResponse.data.response);
          const newServiceBillId = serviceBillResponse.data.response[0]?.servicebillid;
          if (newServiceBillId) {
            localStorage.setItem("selectedservicebillid", newServiceBillId);
          }
        } catch (error) {
          console.error("Error fetching bills:", error);
          toast.error("Failed to fetch bills");
        }
      }
    };
    fetchData();
  }, []);

  const handleUpdateWaterBill = async (bill) => {
    if (!bill) {
      console.error("Water bill is missing.");
      return;
    }
    const selectedBill = waterBill.find((item) => item.waterbill_id === bill);
    setSelectedWaterBill({
      previous_units: selectedBill.currentunits,
      current_units: "",
    });
    setIsUpdateModalOpen(true);
  };

  const handleUpdateWaterBillSubmit = async () => {
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const waterBillId = localStorage.getItem("updatedWaterBillId");
    const requestData = {
      previous_units: selectedWaterBill.previous_units,
      current_units: selectedWaterBill.current_units,
    };
    try {
      await axios.patch(
        `${StandardURL}/iNyumba/admin/waterbill/update/${waterBillId}/${propertyId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const storedRentalId = localStorage.getItem("selectedRentalId");
      const response = await axios.get(
        `${StandardURL}/iNyumba/admin/waterbill/getspecificbyrental/${storedRentalId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWaterBill(response.data.response);
      toast.success("Water bill updated successfully");
      localStorage.setItem("updatedWaterBillId", response.data.response[0]?.waterbill_id);
      setIsUpdateModalOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.response || "Error updating water bill");
      console.error("Error updating water bill:", error);
    }
  };

  const handleCreateBill = async () => {
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const rentalId = localStorage.getItem("selectedRentalId");
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/admin/bill/create-bill/${propertyId}/${rentalId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate(-1);
      toast.success(response.data.response);
    } catch (error) {
      console.error("Error creating bill:", error);
      toast.error(error.response?.data?.response || "Error creating bill");
    }
  };

  const handleAddWaterBill = async () => {
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const rentalId = localStorage.getItem("selectedRentalId");
    const requestData = {
      previous_units: previousUnits,
      current_units: currentUnits,
    };
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/admin/waterbill/create/${propertyId}/${rentalId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setWaterBill(response.data.response);
      toast.success(response.data.response);
      setIsAddWaterBillModalOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.response || "Error adding water bill");
      console.error("Error adding water bill:", error);
    }
  };

  const handleAddTrashBill = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const rentalId = localStorage.getItem("selectedRentalId");
    const requestData = {
      amount: trashAmount,
    };
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/admin/trashbill/create/${propertyId}/${rentalId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setTrashBill(response.data.response);
      toast.success(response.data.response);
      setIsLoading(false);
      setIsAddTrashBillModalOpen(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response?.data?.response || "Error adding trash bill");
      console.error("Error adding trash bill:", error);
    }
  };

  const handleAddServiceBill = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const rentalId = localStorage.getItem("selectedRentalId");
    const requestData = {
      amount: serviceAmount,
    };
    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/admin/servicepropertybill/create/${propertyId}/${rentalId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // Fetch updated service bill
      const serviceBillResponse = await axios.get(
        `${StandardURL}/iNyumba/admin/servicepropertybill/getspecificbyrental/${rentalId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setServiceBill(serviceBillResponse.data.response);
      toast.success(response.data.response);
      localStorage.setItem("selectedservicebillid", serviceBillResponse.data.response[0]?.servicebillid);
      setIsLoading(false);
      setIsAddServiceBillModalOpen(false);
      setServiceAmount(""); // Clear input field
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response?.data?.response || "Error adding service bill");
      console.error("Error adding service bill:", error);
    }
  };

  const handleUpdateServiceBill = async (billId) => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const rentalId = localStorage.getItem("selectedRentalId");
    const requestData = {
      amount: serviceAmount,
    };
    try {
      const response = await axios.patch(
        `${StandardURL}/iNyumba/admin/servicepropertybill/update/${billId}/${propertyId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      // Fetch updated service bill
      const serviceBillResponse = await axios.get(
        `${StandardURL}/iNyumba/admin/servicepropertybill/getspecificbyrental/${rentalId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setServiceBill(serviceBillResponse.data.response);
      toast.success("Service bill updated successfully");
      localStorage.setItem("selectedservicebillid", serviceBillResponse.data.response[0]?.servicebillid);
      setIsLoading(false);
      setIsAddServiceBillModalOpen(false);
      setServiceAmount(""); // Clear input field
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response?.data?.response || "Error updating service bill");
      console.error("Error updating service bill:", error);
    }
  };

  const handleUpdateTrashBill = async (billId) => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const propertyId = localStorage.getItem("selectedPropertyId");
    const requestData = {
      amount: trashAmount,
    };
    try {
      const response = await axios.patch(
        `${StandardURL}/iNyumba/admin/trashbill/update/${billId}/${propertyId}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setTrashBill(response.data.response);
      toast.success("Trash bill updated successfully");
      setIsLoading(false);
      setIsAddTrashBillModalOpen(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.response?.data?.response || "Error updating trash bill");
      console.error("Error updating trash bill:", error);
    }
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 p-4 sm:p-6 lg:p-8">
          <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-6 sm:mb-8">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
                Manage Bills 🧾
              </h1>
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go Back
              </button>
            </div>
            <p className="text-gray-600 mb-8 max-w-2xl">
              Efficiently manage and post water, trash, and service bills to tenants. Ensure all bill data is current before posting.
            </p>
            {/* Main Bill Cards Section */}
            {waterBill && waterBill.length > 0 ? (
              <div className="space-y-6">
                {/* Water Bill Card */}
                <div className="bg-white rounded-xl shadow-lg border border-blue-200 p-6">
                  <h2 className="text-2xl font-bold text-blue-800 mb-4 flex items-center">
                    <svg className="w-7 h-7 mr-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h1M4 12H3m15.325 3.325l-.707.707M6.322 6.322l-.707-.707M18.995 6.995l-.707-.707M6.995 18.995l-.707-.707M8 12h8m-4 4v-8"></path>
                    </svg>
                    Water Bill Details
                  </h2>
                  <div className="text-gray-700 space-y-2 mb-4">
                    <p>
                      <strong className="font-semibold text-gray-800">Previous Units:</strong> {waterBill[0].previousunits}
                    </p>
                    <p>
                      <strong className="font-semibold text-gray-800">Current Units:</strong> {waterBill[0].currentunits}
                    </p>
                  </div>
                  <button
                    onClick={() => handleUpdateWaterBill(waterBill[0].waterbill_id)}
                    className="inline-flex items-center px-5 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                    </svg>
                    Update Water Bill
                  </button>
                </div>
                {/* Trash Bill Card */}
                {trashBill && trashBill.length > 0 ? (
                  <div className="bg-white rounded-xl shadow-lg border border-green-200 p-6">
                    <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                      <svg className="w-7 h-7 mr-3 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                      </svg>
                      Trash Bill Details
                    </h2>
                    <p className="text-gray-700 text-lg font-bold mb-4">
                      <strong className="font-semibold text-gray-800">Amount:</strong> {trashBill[0].amount}
                    </p>
                    <p className="text-sm text-yellow-700 bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4 flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.328 16c-.77 1.333.192 3 1.732 3z"></path>
                      </svg>
                      **Important:** Click "Latest Trash Bill" before "Post Bill to User".
                    </p>
                    <button
                      onClick={() => setIsAddTrashBillModalOpen(true)}
                      className="inline-flex items-center px-5 py-2 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                      </svg>
                      Update Trash Bill
                    </button>
                  </div>
                ) : (
                  <div className="bg-white rounded-xl shadow-lg border border-yellow-200 p-6 text-center">
                    <p className="text-lg text-red-700 font-medium mb-4 flex items-center justify-center">
                      <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.328 16c-.77 1.333.192 3 1.732 3z"></path>
                      </svg>
                      No trash bill found.
                    </p>
                    <p className="text-gray-600 mb-6">
                      Please add or update the trash bill before posting.
                    </p>
                    <button
                      onClick={() => setIsAddTrashBillModalOpen(true)}
                      className="inline-flex items-center px-6 py-2 bg-purple-600 text-white font-semibold rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      Add New Trash Bill
                    </button>
                  </div>
                )}
                {/* Service Bill Card */}
                {serviceBill && serviceBill.length > 0 ? (
                  <div className="bg-white rounded-xl shadow-lg border border-purple-200 p-6">
                    <h2 className="text-2xl font-bold text-purple-800 mb-4 flex items-center">
                      <svg className="w-7 h-7 mr-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      Service Bill Details
                    </h2>
                    <p className="text-gray-700 text-lg font-bold mb-4">
                      <strong className="font-semibold text-gray-800">Amount:</strong> {serviceBill[0].amount}
                    </p>
                    <p className="text-sm text-yellow-700 bg-yellow-50 border border-yellow-200 rounded-md p-3 mb-4 flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.328 16c-.77 1.333.192 3 1.732 3z"></path>
                      </svg>
                      **Important:** Click "Latest Service Bill" before "Post Bill to User".
                    </p>
                    <button
                      onClick={() => setIsAddServiceBillModalOpen(true)}
                      className="inline-flex items-center px-5 py-2 bg-purple-600 text-white font-semibold rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                      </svg>
                      Update Service Bill
                    </button>
                  </div>
                ) : (
                  <div className="bg-white rounded-xl shadow-lg border border-yellow-200 p-6 text-center">
                    <p className="text-lg text-red-700 font-medium mb-4 flex items-center justify-center">
                      <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.328 16c-.77 1.333.192 3 1.732 3z"></path>
                      </svg>
                      No service bill found.
                    </p>
                    <p className="text-gray-600 mb-6">
                      Please add or update the service bill before posting.
                    </p>
                    <button
                      onClick={() => setIsAddServiceBillModalOpen(true)}
                      className="inline-flex items-center px-6 py-2 bg-purple-600 text-white font-semibold rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      Add New Service Bill
                    </button>
                  </div>
                )}
                {/* Post Bill to User Button */}
                <div className="text-center mt-6">
                  <button
                    onClick={handleCreateBill}
                    disabled={isLoading}
                    className={`${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-indigo-600 hover:bg-indigo-700"
                    } inline-flex items-center px-8 py-3 rounded-lg shadow-lg font-bold text-white transition duration-300 ease-in-out transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
                  >
                    {isLoading ? (
                      <Oval
                        height={20}
                        width={20}
                        color="white"
                        visible={true}
                        ariaLabel="loading-indicator"
                        secondaryColor="white"
                      />
                    ) : (
                      <>
                        <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        Post Bill to User
                      </>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg border border-red-200 p-6 text-center">
                <p className="text-lg text-red-700 font-medium mb-4 flex items-center justify-center">
                  <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.328 16c-.77 1.333.192 3 1.732 3z"></path>
                  </svg>
                  No water bill found.
                </p>
                <p className="text-gray-600 mb-6">
                  Please add a water bill before proceeding to post bills to users.
                </p>
                <button
                  onClick={() => setIsAddWaterBillModalOpen(true)}
                  className="inline-flex items-center px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out transform hover:-translate-y-0.5"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  Add Water Bill
                </button>
              </div>
            )}
          </div>
        </div>
        {/* --- Add Trash Bill Modal --- */}
        {isAddTrashBillModalOpen && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900 bg-opacity-75 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden transform transition-all sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Add/Update Trash Bill 🗑️
                </h3>
                <div className="mb-4">
                  <label htmlFor="trashAmount" className="block text-sm font-medium text-gray-700 mb-2">
                    Trash Amount:
                  </label>
                  <input
                    type="number"
                    id="trashAmount"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    value={trashAmount}
                    onChange={(e) => setTrashAmount(e.target.value)}
                  />
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse gap-3">
                <button
                  onClick={() => (trashBill && trashBill.length > 0 ? handleUpdateTrashBill(trashBill[0].trashbillid) : handleAddTrashBill())}
                  disabled={isLoading}
                  className={`${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700"
                  } w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 text-base font-medium text-white transition duration-300 ease-in-out sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                >
                  {isLoading ? (
                    <Oval height={20} width={20} color="white" />
                  ) : (
                    trashBill && trashBill.length > 0 ? "Update Trash Bill" : "Add Trash Bill"
                  )}
                </button>
                <button
                  onClick={() => setIsAddTrashBillModalOpen(false)}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 transition duration-300 ease-in-out sm:mt-0 sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {/* --- Add Service Bill Modal --- */}
        {isAddServiceBillModalOpen && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900 bg-opacity-75 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden transform transition-all sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Add/Update Service Bill 💸
                </h3>
                <div className="mb-4">
                  <label htmlFor="serviceAmount" className="block text-sm font-medium text-gray-700 mb-2">
                    Service Amount:
                  </label>
                  <input
                    type="number"
                    id="serviceAmount"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    value={serviceAmount}
                    onChange={(e) => setServiceAmount(e.target.value)}
                  />
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse gap-3">
                <button
                  onClick={() => (serviceBill && serviceBill.length > 0 ? handleUpdateServiceBill(serviceBill[0].servicebillid) : handleAddServiceBill())}
                  disabled={isLoading}
                  className={`${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700"
                  } w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 text-base font-medium text-white transition duration-300 ease-in-out sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                >
                  {isLoading ? (
                    <Oval height={20} width={20} color="white" />
                  ) : (
                    serviceBill && serviceBill.length > 0 ? "Update Service Bill" : "Add Service Bill"
                  )}
                </button>
                <button
                  onClick={() => setIsAddServiceBillModalOpen(false)}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 transition duration-300 ease-in-out sm:mt-0 sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {/* --- Add Water Bill Modal --- */}
        {isAddWaterBillModalOpen && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900 bg-opacity-75 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden transform transition-all sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Add Water Bill 💧
                </h3>
                <div className="space-y-4">
                  <div className="relative">
                    <label htmlFor="previousUnits" className="block text-sm font-medium text-gray-700 mb-1">
                      Previous Units:
                    </label>
                    <input
                      type="number"
                      id="previousUnits"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={previousUnits}
                      onChange={(e) => setPreviousUnits(e.target.value)}
                      placeholder="Enter previous units"
                    />
                  </div>
                  <div className="relative">
                    <label htmlFor="currentUnits" className="block text-sm font-medium text-gray-700 mb-1">
                      Current Units:
                    </label>
                    <input
                      type="number"
                      id="currentUnits"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={currentUnits}
                      onChange={(e) => setCurrentUnits(e.target.value)}
                      placeholder="Enter current units"
                    />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse gap-3">
                <button
                  onClick={handleAddWaterBill}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 transition duration-300 ease-in-out sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Submit
                </button>
                <button
                  onClick={() => setIsAddWaterBillModalOpen(false)}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 transition duration-300 ease-in-out sm:mt-0 sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        {/* --- Update Water Bill Modal --- */}
        {isUpdateModalOpen && selectedWaterBill && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900 bg-opacity-75 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden transform transition-all sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Update Water Bill ✏️
                </h3>
                <div className="space-y-4">
                  <div className="relative">
                    <label htmlFor="previousUnits" className="block text-sm font-medium text-gray-700 mb-1">
                      Previous Units:
                    </label>
                    <input
                      type="text"
                      id="previousUnits"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-50 cursor-not-allowed"
                      value={selectedWaterBill.previous_units}
                      readOnly
                    />
                  </div>
                  <div className="relative">
                    <label htmlFor="currentUnits" className="block text-sm font-medium text-gray-700 mb-1">
                      Current Units:
                    </label>
                    <input
                      type="number"
                      id="currentUnits"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={selectedWaterBill.current_units}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        setSelectedWaterBill({
                          ...selectedWaterBill,
                          current_units: inputValue,
                        });
                      }}
                      placeholder="Enter new current units"
                    />
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse gap-3">
                <button
                  onClick={handleUpdateWaterBillSubmit}
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-6 py-3 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 transition duration-300 ease-in-out sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Submit
                </button>
                <button
                  onClick={() => setIsUpdateModalOpen(false)}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-100 transition duration-300 ease-in-out sm:mt-0 sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </AuthGuard>
    </RoleGuard>
  );
};

export default BillsPage;